export default class EditorInfoController {
    constructor() {
        this.WEBPARTS = document.querySelectorAll('body.EditMode .WebPart');
        this.PREVIEW_NODES = [];
        this.assignIcons();
        this.registerClickEvents();
    }

    assignIcons() {
        this.WEBPARTS.forEach((webpart) => {
            const editorInfo = webpart.querySelector('div.WebPartContent > [data-editor-info]');
            if (editorInfo !== null) {
                const handle = webpart.querySelector('.WebPartHandle');
                const infoNode = document.createElement('i');
                infoNode.className = 'WebPartActionButton icon-editor-info';
                infoNode.title = 'widget widths on desktop, tablet and mobile devices';
                infoNode.textContent = editorInfo.dataset.editorInfo;
                const previewNode = document.createElement('i');
                previewNode.className = 'WebPartActionButton fa fa-lg fa-angle-double-up fold-icon';
                previewNode.title = 'collapse all widgets to simplify the drag-and-drop widget rearrangement';
                handle.prepend(previewNode);
                handle.prepend(infoNode);
                this.PREVIEW_NODES = document.querySelectorAll('body.EditMode .WebPart .WebPartHandle .fold-icon');
            }
        }, this);
    }

    registerClickEvents() {
        document.addEventListener('click', (event) => {
            if (event.target.matches('.WebPartActionButton.fa')) {
                event.stopPropagation();
                event.preventDefault();
                this.PREVIEW_NODES.forEach((handle) => {
                    handle.closest('.WebPart').classList.toggle('collapsed');
                    handle.classList.toggle('fa-angle-double-up');
                    handle.classList.toggle('fa-angle-double-down');
                });
            }
        }, false);
    }

    static init() {
        document.addEventListener('DOMContentLoaded', () => {
            new EditorInfoController(); // eslint-disable-line no-new
        });
    }
}
